export default "__VITE_ASSET__DEMRNPYT__"